import { useEffect } from "react";

const WasherRepair = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#222222] text-white">
      <div className="grid grid-cols-1 md:grid-cols-2 min-h-screen">
        {/* Image container with mobile optimization */}
        <div className="h-[40vh] md:h-screen relative">
          <img
            src="/lovable-uploads/e8e18826-285a-4452-8912-0793e5e59e4a.png"
            alt="Washer repair service"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="p-8 overflow-y-auto">
          <h1 className="text-4xl font-bold mb-8 text-accent">Washer Repair Services</h1>
          <div className="space-y-6">
            <section>
              <h2 className="text-2xl font-semibold text-accent-light mb-4">Expert Washer Repair Services in GTA</h2>
              <p className="text-gray-300 mb-4">
                Our professional washer repair service covers all major brands and models. With years of experience,
                our certified technicians are equipped to handle any washing machine issue you may encounter.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-accent-light mb-3">Our Services Include:</h3>
              <ul className="list-disc list-inside text-gray-300 space-y-2">
                <li>Water leak repairs</li>
                <li>Drum and bearing replacements</li>
                <li>Motor and pump repairs</li>
                <li>Control board diagnostics and repair</li>
                <li>Belt and pulley system maintenance</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-accent-light mb-3">Why Choose Us?</h3>
              <ul className="space-y-4 text-gray-300">
                <li>✓ Same-day service available</li>
                <li>✓ Certified technicians</li>
                <li>✓ Warranty on parts and labor</li>
                <li>✓ Competitive pricing</li>
                <li>✓ Emergency repairs available</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-accent-light mb-3">Common Washer Issues We Fix</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-300">
                <div>• Washer won't start</div>
                <div>• Unusual noises</div>
                <div>• Water leaks</div>
                <div>• Spin cycle issues</div>
                <div>• Drainage problems</div>
                <div>• Door lock malfunctions</div>
              </div>
            </section>

            <div className="mt-8">
              <a
                href="tel:416-805-5075"
                className="bg-accent hover:bg-accent-hover text-white px-6 py-3 rounded-lg inline-block transition-colors"
              >
                Call Now for Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WasherRepair;
